<nb-action class="close-dialog" icon="close-outline" (click)="closeAction()"></nb-action>

<nb-card>
  <nb-card-header>Sélectionner une exploitation</nb-card-header>
  <nb-card-body>
    @if (companies && companies.length > 0) {
      <nb-list>
        @for (company of companies; track company) {
          <nb-list-item
            [class.active]="company.id === currentCompanyId"
            >
            <div class="d-flex justify-content-between align-items-center w-100">
              <div (click)="selectCompany(company)" style="cursor: pointer; flex: 1">
                <strong>{{ company.name }}</strong>
                <br />
                <small class="text-muted">{{ company.city }}</small>
              </div>
            </div>
          </nb-list-item>
        }
      </nb-list>
    }

    @if (loading) {
      <nb-spinner size="large"></nb-spinner>
    }
  </nb-card-body>
</nb-card>
